module.exports = __webpack_public_path__ + "img/responsabilidad-fundacion.6f70840d.png";